<template>
    <BaseSection
        v-if="orderedSubsidies.length > 0"
        class="subsidy-group"
        width="page-narrow"
    >
        <h2
            v-if="title"
            class="subsidy-group__title"
        >
            {{ title }} ({{ subsidies?.length ?? 0 }})
        </h2>
        <SubsidyCard
            v-for="(subsidy, key) in orderedSubsidies"
            :key="key"
            :subsidy="subsidy"
        />
    </BaseSection>
</template>

<script>
import subsidyMixin from '~/mixins/subsidy';

export default {
    mixins: [subsidyMixin],
    props: {
        subsidies: {
            type: Array,
            default() {
                return [];
            }
        },
        title: {
            type: String,
            default: ''
        }
    },
    computed: {
        orderedSubsidies() {
            const sorted = this.subsidies;
            return sorted.sort((a, b) => {
                const aIsActive = this.isActivePeriod(a.periodsRelation);
                const bIsActive = this.isActivePeriod(b.periodsRelation);

                if (!aIsActive && bIsActive) {
                    return 1;
                }
                if (aIsActive && !bIsActive) {
                    return -1;
                }
                return 0;
            });
        }
    },
};
</script>

<style lang="less" src="./SubsidyGroup.less" />
